(function () {
  var home = (window.JOVSHome = window.JOVSHome || {});
  if (home.runtimeReady || typeof Swiper === "undefined") return;
  home.root = document.querySelector(".home-rebuild-root");
  if (!home.root) return;

  home.swiperProhibitSelectSlidesCount = document.querySelectorAll(".swiper-prohibit-select .swiper-wrapper > .swiper-slide").length;
  home.swiperTopBannerProgressFill = document.querySelector("#section-top-banner .swiper-progress-bar-fill");
  home.swiperTopBannerPrevButton = document.querySelector("#section-top-banner .swiper-top-banner-progress .btn-swiper-prev");
  home.swiperTopBannerNextButton = document.querySelector("#section-top-banner .swiper-top-banner-progress .btn-swiper-next");
  home.topBannerMediaQuery = window.matchMedia("(max-width: 992px)");
  home.topBannerDesktopVideo = document.querySelector('#section-top-banner .item-video video[data-top-banner-variant="desktop"]');
  home.topBannerMobileVideo = document.querySelector('#section-top-banner .item-video video[data-top-banner-variant="mobile"]');
  home.swiperProhibitSelectProgressFill = document.querySelector("#section-prohibit-select .swiper-progress-bar-fill");
  home.swiperShopByConcernProgressFill = document.querySelector("#section-shop-by-concern .swiper-progress-bar-fill");
  home.swiperProhibitSelectPrevButton = document.querySelector(".swiper-prohibit-select-progress .btn-swiper-prev");
  home.swiperProhibitSelectNextButton = document.querySelector(".swiper-prohibit-select-progress .btn-swiper-next");
  home.swiperShopByConcernPrevButton = document.querySelector("#section-shop-by-concern .swiper-shop-by-concern-progress .btn-swiper-prev");
  home.swiperShopByConcernNextButton = document.querySelector("#section-shop-by-concern .swiper-shop-by-concern-progress .btn-swiper-next");
  home.swiperTrustedRecommendedProgressFill = document.querySelector("#section-trusted-recommended .swiper-progress-bar-fill");
  home.swiperTrustedRecommendedPrevButton = document.querySelector("#section-trusted-recommended .btn-swiper-prev");
  home.swiperTrustedRecommendedNextButton = document.querySelector("#section-trusted-recommended .btn-swiper-next");
  home.swiperAddBlogProgressFill = document.querySelector("#section-add-blog .swiper-progress-bar-fill");
  home.swiperAddBlogPrevButton = document.querySelector("#section-add-blog .btn-swiper-prev");
  home.swiperAddBlogNextButton = document.querySelector("#section-add-blog .btn-swiper-next");
  home.swiperAddTextCardProgressFill = document.querySelector("#section-add-text-card .swiper-progress-bar-fill");
  home.swiperAddTextCardPrevButton = document.querySelector("#section-add-text-card .btn-swiper-prev");
  home.swiperAddTextCardNextButton = document.querySelector("#section-add-text-card .btn-swiper-next");
  home.swiperOurMissionProgressFill = document.querySelector("#section-our-mission .swiper-progress-bar-fill");
  home.swiperOurMissionPrevButton = document.querySelector("#section-our-mission .btn-swiper-prev");
  home.swiperOurMissionNextButton = document.querySelector("#section-our-mission .btn-swiper-next");
  home.swiperAddTextCardElement = document.querySelector(".swiper-add-text-card");
  home.swiperAddTextCardMediaQuery = window.matchMedia("(max-width: 991px)");
  home.swiperAddTextCard = null;
  home.addTextCardSection = document.querySelector("#section-add-text-card");
  home.swiperAwardsLogoElement = document.querySelector(".swiper-awards-logo-list");
  home.swiperAwardsLogoMediaQuery = window.matchMedia("(max-width: 991px)");
  home.swiperAwardsLogo = null;
  home.awardsLogoSection = document.querySelector("#section-awards-logo-list");
  home.prohibitSelectSection = document.querySelector("#section-prohibit-select");
  home.shopByConcernSection = document.querySelector("#section-shop-by-concern");
  home.swiperShopByConcernElement = document.querySelector(".swiper-shop-by-concern");
  home.swiperShopByConcernMediaQuery = window.matchMedia("(max-width: 992px)");
  home.userEvaluationSection = document.querySelector("#section-user-evaluation");
  home.trustedRecommendedSection = document.querySelector("#section-trusted-recommended");
  home.ourMissionSection = document.querySelector("#section-our-mission");
  home.addBlogSection = document.querySelector("#section-add-blog");
  home.swiperProhibitSelectThumb = null;
  home.swiperProhibitSelect = null;
  home.swiperShopByConcern = null;
  home.swiperUserEvaluation = null;
  home.swiperTrustedRecommended = null;
  home.swiperOurMissionThumb = null;
  home.swiperOurMission = null;
  home.swiperAddBlog = null;
  home.swiperTopBanner = null;
  home.awardsLogoManagerInitialized = false;
  home.addTextCardManagerInitialized = false;
  home.shopByConcernManagerInitialized = false;
  home.prohibitSelectNavigationBound = false;
  home.ourMissionNextMaxIndex = Math.max(document.querySelectorAll("#section-our-mission .swiper-our-mission-thumb .swiper-slide").length - 1, 0);
  home.halfCardShowSection = document.querySelector("#section-half-card-show");
  home.halfCardShowItems = home.halfCardShowSection ? home.halfCardShowSection.querySelectorAll(".content-wrap > .item") : [];
  home.halfCardShowMediaQuery = window.matchMedia("(max-width: 992px)");

  home.updateProhibitSelectProgress = function (swiper) {
    if (!home.swiperProhibitSelectProgressFill || !home.swiperProhibitSelectSlidesCount) return;
    home.swiperProhibitSelectProgressFill.style.width = ((swiper.realIndex + 1) / home.swiperProhibitSelectSlidesCount) * 100 + "%";
  };

  home.getSwiperVisibleSlidesCount = function (swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return 1;
    if (typeof swiper.slidesPerViewDynamic === "function") {
      var dynamicSlidesCount = swiper.slidesPerViewDynamic();
      if (dynamicSlidesCount) return dynamicSlidesCount;
    }
    if (swiper.params && typeof swiper.params.slidesPerView === "number" && swiper.params.slidesPerView > 0) {
      return swiper.params.slidesPerView;
    }
    return 1;
  };

  home.updateShopByConcernProgress = function (swiper) {
    if (!home.swiperShopByConcernProgressFill || !swiper || !swiper.slides.length) return;
    var visibleSlidesCount = home.getSwiperVisibleSlidesCount(swiper);
    var stepsCount = Math.max(swiper.slides.length - visibleSlidesCount + 1, 1);
    var currentStep = Math.min((typeof swiper.activeIndex === "number" ? swiper.activeIndex : 0) + 1, stepsCount);
    home.swiperShopByConcernProgressFill.style.width = (currentStep / stepsCount) * 100 + "%";
  };

  home.updateSwiperProgress = function (swiper, progressFill) {
    if (!progressFill) return;
    var stepsCount = swiper.snapGrid && swiper.snapGrid.length ? swiper.snapGrid.length : swiper.slides.length;
    if (!stepsCount) return;
    progressFill.style.width = ((typeof swiper.snapIndex === "number" ? swiper.snapIndex + 1 : 1) / stepsCount) * 100 + "%";
  };

  home.updateOurMissionProgress = function (swiper) {
    home.updateSwiperProgress(swiper, home.swiperOurMissionProgressFill);
  };

  home.getOurMissionNextLimit = function (swiper) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return home.ourMissionNextMaxIndex;
    return Math.min(home.ourMissionNextMaxIndex, swiper.slides.length - 1);
  };

  home.updateOurMissionNextButtonState = function (swiper) {
    if (!home.swiperOurMissionNextButton || !swiper) return;
    home.swiperOurMissionNextButton.classList.toggle("swiper-button-disabled-limit", swiper.activeIndex >= home.getOurMissionNextLimit(swiper));
    home.refreshAccessibleSwiperControls();
  };

  home.handleOurMissionNextButtonClick = function (event) {
    if (!home.swiperOurMission || home.swiperOurMission.activeIndex < home.getOurMissionNextLimit(home.swiperOurMission)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };

  home.isOurMissionMobileLayout = function () {
    return window.innerWidth <= 992;
  };

  home.setHalfCardShowActiveItem = function (targetItem) {
    if (!home.halfCardShowItems.length || !targetItem) return;
    home.halfCardShowItems.forEach(function (item) {
      item.classList.toggle("is-active", item === targetItem);
    });
  };

  home.syncHalfCardShowActiveItem = function () {
    if (!home.halfCardShowItems.length || !home.halfCardShowMediaQuery.matches) return;
    var activeItem = home.halfCardShowSection.querySelector(".content-wrap > .item.is-active") || home.halfCardShowItems[0];
    home.setHalfCardShowActiveItem(activeItem);
  };

  home.isVisibleElement = function (element) {
    return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  };

  home.ensureTopBannerVideoSources = function (video) {
    if (!video || video.dataset.sourcesLoaded === "true") return;
    var sources = video.querySelectorAll("source");
    var shouldLoad = false;
    Array.prototype.forEach.call(sources, function (source) {
      var dataSrc = source.getAttribute("data-src");
      if (dataSrc && !source.getAttribute("src")) {
        source.setAttribute("src", dataSrc);
        shouldLoad = true;
      }
    });
    if (shouldLoad) video.load();
    video.dataset.sourcesLoaded = "true";
  };

  home.syncTopBannerVideos = function (swiper) {
    if (!swiper || !swiper.el) return;
    var bannerVideos = swiper.el.querySelectorAll(".item-video video");
    Array.prototype.forEach.call(bannerVideos, function (video) {
      video.pause();
    });
    var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
    if (!activeSlide || !activeSlide.classList.contains("item-video")) return;
    Array.prototype.forEach.call(activeSlide.querySelectorAll("video"), function (video) {
      if (!home.isVisibleElement(video)) return;
      home.ensureTopBannerVideoSources(video);
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") playPromise.catch(function () {});
    });
  };

  home.requestTopBannerVideoSync = function (swiper) {
    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(function () {
        home.syncTopBannerVideos(swiper);
      });
      return;
    }
    setTimeout(function () {
      home.syncTopBannerVideos(swiper);
    }, 0);
  };

  home.getInitialTopBannerVideo = function () {
    return home.topBannerMediaQuery.matches ? home.topBannerMobileVideo : home.topBannerDesktopVideo;
  };

  home.primeTopBannerHeroMedia = function () {
    home.ensureTopBannerVideoSources(home.getInitialTopBannerVideo());
  };

  home.bindMediaQueryChange = function (mediaQuery, handler) {
    if (!mediaQuery || !handler) return;
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handler);
    } else {
      mediaQuery.addListener(handler);
    }
  };

  home.getSwiperControlLabel = function (control) {
    if (!control) return "";
    if (control.classList.contains("btn-swiper-prev") || control.classList.contains("swiper-button-prev")) return "Previous slide";
    if (control.classList.contains("btn-swiper-next") || control.classList.contains("swiper-button-next")) return "Next slide";
    return "";
  };

  home.isSwiperControlElement = function (element) {
    return !!(element && element.classList && (element.classList.contains("swiper-arrow") || element.classList.contains("swiper-button-prev") || element.classList.contains("swiper-button-next")));
  };

  home.refreshAccessibleSwiperControls = function () {
    var swiperControls = document.querySelectorAll(".swiper-arrow, .swiper-button-prev, .swiper-button-next");
    Array.prototype.forEach.call(swiperControls, function (control) {
      var label = home.getSwiperControlLabel(control);
      var isDisabled = control.classList.contains("swiper-button-disabled") || control.classList.contains("swiper-button-disabled-limit");
      var icon = control.querySelector("svg");
      if (!control.dataset.a11yControlBound) {
        control.dataset.a11yControlBound = "true";
        control.addEventListener("keydown", function (event) {
          var key = event.key;
          if (key !== "Enter" && key !== " " && key !== "Spacebar") return;
          event.preventDefault();
          if (control.getAttribute("aria-disabled") === "true") return;
          control.click();
        });
      }
      control.setAttribute("role", "button");
      if (label && !control.getAttribute("aria-label")) control.setAttribute("aria-label", label);
      control.setAttribute("aria-disabled", isDisabled ? "true" : "false");
      control.setAttribute("tabindex", isDisabled ? "-1" : "0");
      if (icon) {
        icon.setAttribute("aria-hidden", "true");
        icon.setAttribute("focusable", "false");
      }
    });
  };

  home.initAccessibleSwiperControls = function () {
    home.refreshAccessibleSwiperControls();
    if (!("MutationObserver" in window)) return;
    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = mutations.some(function (mutation) {
        if (mutation.type === "childList") {
          return Array.prototype.some.call(mutation.addedNodes, home.isSwiperControlElement) || Array.prototype.some.call(mutation.removedNodes, home.isSwiperControlElement);
        }
        return home.isSwiperControlElement(mutation.target);
      });
      if (shouldRefresh) home.refreshAccessibleSwiperControls();
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  };

  home.initSwiperWhenVisible = function (element, initSwiper, rootMargin) {
    if (!element || !initSwiper) return;
    if (!("IntersectionObserver" in window)) {
      initSwiper();
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        initSwiper();
      });
    }, {
      rootMargin: rootMargin || "400px 0px",
    });
    observer.observe(element);
  };

  home.primeTopBannerHeroMedia();
  home.bindMediaQueryChange(home.topBannerMediaQuery, home.primeTopBannerHeroMedia);
  home.initAccessibleSwiperControls();
  home.runtimeReady = true;
})();
